import { createContext } from "react";
import { DEFAULT_YEAR_RANGE } from "../../../constants.js";
const DatePickerContext = createContext({
  selected: void 0,
  current: null,
  yearRange: DEFAULT_YEAR_RANGE
});
export {
  DatePickerContext
};
//# sourceMappingURL=DatePickerContext.js.map
